import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DesignerLink, DesignerLinkWrapper } from './styled';

// TODO: refactor in functional component
class DesignerListLink extends Component {
  render() {
    const { alias, url, name } = this.props;
    return (
      <DesignerLinkWrapper>
        <DesignerLink data-cy={`link-designer-${alias}`} id={`${alias}`} href={url}>
          {name}
        </DesignerLink>
      </DesignerLinkWrapper>
    );
  }
}

DesignerListLink.propTypes = {
  alias: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default DesignerListLink;
